<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background" #individualPlanReview>
  @if (!formConfig.form.customConfigs?.reviewOnly) {
    <!-- Form Page Heading -->
    @if (formConfig.pages[currentPage]?.showPageHeader) {
      <h1>
      {{ formConfig.pages[currentPage]?.pageHeader || 'Review and Submit your Application' }}</h1>
    }
    <span>{{ formConfig.pages[currentPage]?.subHeader || 'Please review your application responses to verify your information.'}}</span>
    <!-- Form Entries Loop  *ngIf="reviewConfigReady -->
    @for (entry of formConfig.pages[currentPage]?.custom?.entriesDefaultBehavior; track entry; let i = $index) {
<div>
      <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
      </ptl-entry-as-json>
    </div>
}
  
}

  @if (reviewConfigReady) {

    @for (section of formattedEntries; track section; let i = $index) {
<div class="form-entries">
      @if (section[0].pageNumber <= currentPage) {

        <div class="section-header-and-edit">
          <h4 class="bottom-separation-line">
            <b [innerHTML]="section[0]?.formControlAttributes?.label"></b>
          </h4>
          @if (!formConfig.form.customConfigs?.reviewOnly && section[0].formControlAttributes?.formControlName) {
<button mat-raised-button
           
            class="edit-button" color="secondary" (click)="editQuestion(section[0])">
                Edit {{ section[0].formControlAttributes?.label }}
              </button>
            }
          </div>
          <!-- CONTROL VALUE + EDIT -->
          @for (entry of section[1]; track entry; let j = $index) {
<div [ngClass]="{
          'single-column-format': !isLongString(entry?.formControlAttributes?.label),
          'full-width-padded' : isLongString(entry?.formControlAttributes?.label),
          'full-width': entry?.custom?.dependentHeader, 
          'top-separation-line' : entry?.custom?.dependentHeader && entry?.custom?.dependentNum !== 1}">
              @if ((
                entry.formControlAttributes?.formControlName &&
                !entry.custom?.doNotDisplayOnReviewPage
                )) {
                @if (!entry?.custom?.dependentHeader) {
                  <b [innerHTML]=" entry?.formControlAttributes?.label"></b>
                }
                @if (entry?.custom?.dependentHeader) {
                  <h4>
                    {{ entry?.formControlAttributes?.label }}
                  </h4>
                }
                @if (!entry?.custom?.dependentHeader) {
                  <div>{{ retrieveEntry(entry) || "Review" }} </div>
                }
              } @else {
                @if (entry.custom?.displayOnPrintReview) {
                  @if (entry?.base?.display) {
                    <div [innerHTML]="retrieveSafeHTML(entry)"></div>
                  }
                }
              }
              <!-- CONTENT VALUE-->
            </div>
          }
        }
      </div>
    }
  }

  <!-- Form Page Nav BUTTONS -->
  @if (!formConfig.form.customConfigs?.reviewOnly) {
    <div class="form-buttons">
      @if (formConfig.form.formNavigation.saveButton.display) {
        <div class="save-later">
          <a href="javascript:void(0)" (click)="saveForLaterButton()">
            <span class="text">SAVE FOR LATER</span>
            <span class="material-symbols-outlined save-icon">save</span>
          </a>
        </div>
      }
      <div class="navigational-controls">
        @if (formConfig.form.formNavigation.backButton.display && currentPage !== 0) {
          <div class="nav-link">
            <a href="javascript:void(0)" (click)="backButton()">
              <span class="material-symbols-outlined">arrow_back</span>
              <span class="text left-text">BACK</span>
            </a>
          </div>
        }
        @if (formConfig.form.formNavigation.nextButton.display && currentPage !== formConfig.pages.length - 1) {
          <div class="nav-link spacer" [ngClass]="{'disable-link' : false }"
            >
            <a href="javascript:void(0)" (click)="nextButton()">
              <span class="text">NEXT</span>
              <span class="material-symbols-outlined">arrow_forward</span>
            </a>
          </div>
        }
      </div>
      @if (currentPage === formConfig.pages.length - 1) {
        <button mat-raised-button color="primary" class="submit-button"
          [disabled]="isSubmitting" (click)="submitButton()">
          SUBMIT
        </button>
      }
    </div>
  }
</div>